<template>
  <el-dialog title="主站设置" :visible.sync="dialogVisible" width="500px" :append-to-body="true" @close="handleClose" style="text-align: center;color: white;" >
    <el-form :model="formData" label-width="100px" size="small">
      <el-form-item label="主站地址">
        <el-input v-model="formData.host" placeholder="请输入主站地址" />
      </el-form-item>
      <el-form-item label="端口">
        <el-input v-model="formData.port" placeholder="请输入端口号" />
      </el-form-item>
      <el-form-item label="用户名">
        <el-input v-model="formData.username" placeholder="请输入用户名"/>
      </el-form-item> 
      <el-form-item label="密码">
        <el-input v-model="formData.password" type="password"  placeholder="请输入密码" show-password />
      </el-form-item>
       <el-form-item label="发布主题">
        <el-input v-model="formData.topic" placeholder="请输入发布主题" />
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button icon="el-icon-close" @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" icon="el-icon-check" @click="handleSave">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios'

const API_BASE = '/mqtt'

export default {
  name: 'MasterSetting',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        host: '',
        port: '',
        username: '',
        password: '',
        topic: ''
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.loadConfig()
      }
    }
  },
  methods: {
    async loadConfig() {
      try {
        const res = await axios.get(`${API_BASE}/master/getConfig`)
        if (res.data.code === 200) {
          this.formData = res.data.data
        }
      } catch (error) {
        console.error('加载主站配置失败:', error)
      }
    },
    async handleSave() {
      try {
        const res = await axios.post(`${API_BASE}/master/config`, this.formData)
        if (res.data.code === 200) {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.$emit('saved')
        } else {
          this.$message.error(res.data.message)
        }
      } catch (error) {
        this.$message.error('保存失败')
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style>
.el-dialog__title{
  color: aliceblue !important;
}

</style>
